import React from 'react';
import { Link } from "react-router-dom";
import './footersection.component.css';

// Footer link columns. Items without a `to` render as non-linking
// placeholders (pages coming later, e.g. About / Contact).
const FOOTER_COLUMNS = [
  {
    heading: 'Product',
    links: [
      { label: 'Oculo', to: '/apps/oculo' },
      { label: 'Digital NDT Workflow', to: '/features' },
      { label: 'AI Oversight', to: '/apps/prime' },
    ],
  },
  {
    heading: 'Solutions',
    links: [
      { label: 'On-Demand Expertise', to: '/solutions' },
      { label: 'AI Quality Program', to: '/solutions/ai-quality-program' },
    ],
  },
  {
    heading: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Careers', to: '/careers' },
      { label: 'News', to: '/news' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms & Conditions', to: '/terms-of-services' },
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Cookie Policy', to: '/cookie-policy' },
      { label: 'Acceptable Use', to: '/acceptable-use' },
    ],
  },
];

const FooterSection = () => {
  return (
    <>
      <footer className="footer-v2 bg-dark dark-mode">
        <div className="footer-v2-content">

          {/* Top: brand block + link columns */}
          <div className="footer-v2-top">
            <div className="footer-v2-brand">
              <div className="footer-v2-logo">
                <Link to="/">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/logo_large 1.png`} width="149" alt="orbix" />
                </Link>
              </div>

              <p className="footer-v2-description">
                The NDT Platform that Enables Technicians, Quality Teams, and AI Agents to Work Together.
              </p>

              <div className="footer-v2-socials-flag">
                <a href="https://www.linkedin.com/company/orbix-nde/" target="_blank" rel="noopener noreferrer" className="footer-v2-social-btn">
                  <i className="bx bxl-linkedin"></i>
                </a>
                <a href="https://www.youtube.com/watch?v=GReRpmRuSS4" target="_blank" rel="noopener noreferrer" className="footer-v2-social-btn">
                  <i className="bx bxl-youtube"></i>
                </a>
                <div className="footer-v2-flag">
                  <img src={`${process.env.PUBLIC_URL}/assets/img/united-states-flag.png`} width="44" height="44" alt="US" />
                </div>
              </div>
            </div>

            <nav className="footer-v2-cols" aria-label="Footer">
              {FOOTER_COLUMNS.map((col) => (
                <div className="footer-v2-col" key={col.heading}>
                  <h4 className="footer-v2-col-heading">{col.heading}</h4>
                  <ul className="footer-v2-col-list">
                    {col.links.map((link) => (
                      <li key={link.label}>
                        {link.to ? (
                          <Link to={link.to} className="footer-v2-col-link">{link.label}</Link>
                        ) : (
                          <span className="footer-v2-col-link footer-v2-col-link--soon">{link.label}</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </nav>
          </div>

          {/* Gradient divider */}
          <div className="footer-v2-divider"></div>

          {/* Bottom: copyright */}
          <div className="footer-v2-bottom">
            <div className="footer-v2-copyright">
              <svg className="footer-v2-copyright-icon" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 1.08C3.46 1.08 1.08 3.46 1.08 6.5C1.08 9.54 3.46 11.92 6.5 11.92C9.54 11.92 11.92 9.54 11.92 6.5C11.92 3.46 9.54 1.08 6.5 1.08ZM6.5 10.83C4.06 10.83 2.17 8.94 2.17 6.5C2.17 4.06 4.06 2.17 6.5 2.17C8.94 2.17 10.83 4.06 10.83 6.5C10.83 8.94 8.94 10.83 6.5 10.83Z" fill="white"/>
                <path d="M7.58 4.88C7.31 4.67 6.98 4.58 6.5 4.58C5.42 4.58 4.87 5.27 4.87 6.5C4.87 7.73 5.42 8.42 6.5 8.42C6.98 8.42 7.31 8.33 7.58 8.12V9.04C7.23 9.21 6.85 9.29 6.39 9.29C4.87 9.29 3.92 8.35 3.92 6.5C3.92 4.65 4.87 3.71 6.39 3.71C6.85 3.71 7.23 3.79 7.58 3.96V4.88Z" fill="white"/>
              </svg>
              <span className="footer-v2-copyright-text">
                Orbix 2026. All Rights Reserved
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterSection;
